class ProductStickyAtc {
  constructor(element) {
    this.element = element;
    this.button = element.querySelector('[data-sticky-atc-button]');
    this.mainButton = document.getElementById(element.dataset.mainAddId);

    if (!this.button || !this.mainButton) return;

    this.button.addEventListener('click', () => {
      if (!this.mainButton.disabled) this.mainButton.click();
    });

    this.syncButton();
    this.buttonObserver = new MutationObserver(() => this.syncButton());
    this.buttonObserver.observe(this.mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.element.classList.toggle('product-sticky-atc--visible', shouldShow);
        this.element.setAttribute('aria-hidden', String(!shouldShow));
      },
      { threshold: 0 }
    );
    this.visibilityObserver.observe(this.mainButton);
  }

  syncButton() {
    this.button.disabled = this.mainButton.disabled;
    const label = this.mainButton.querySelector('span')?.textContent?.trim();
    if (label) this.button.textContent = label;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sticky-atc]').forEach((element) => new ProductStickyAtc(element));
});
